import { render, staticRenderFns } from "./MessageActionPopover.vue?vue&type=template&id=cb528c98&scoped=true&"
import script from "./MessageActionPopover.vue?vue&type=script&lang=js&"
export * from "./MessageActionPopover.vue?vue&type=script&lang=js&"
import style0 from "./MessageActionPopover.vue?vue&type=style&index=0&id=cb528c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb528c98",
  null
  
)

export default component.exports